/**
 * Normalize MongoDB _id (string or { $oid: "..." }) to a plain string for comparison and form values.
 */
export function normalizeId(v) {
  if (v == null || v === "") return "";
  if (typeof v === "object" && v?.$oid) return String(v.$oid);
  return String(v).trim();
}

export function idsMatch(a, b) {
  const sa = normalizeId(a);
  const sb = normalizeId(b);
  return sa.length > 0 && sb.length > 0 && sa === sb;
}
